<template>
  <div class="col col-cx mr-2">
    <Slider
      v-model="dateNew"
      :min="0"
      :max="dates.length - 1"
      @change="onUserSlider"
      @input="handleSliderChange"
      :disabled="isDisabled"
    />
  </div>
</template>

<script>
import { select, axisBottom, timeFormat } from "d3";
import Slider from "primevue/slider";
import { Slider as SliderRefactor } from "../../_core/refactor/figures/Slider";

export default {
  name: "Slider1",
  components: {
    Slider,
  },
  props: {
    dates: { required: true },
    minIdx: { required: true, default: 0 },
    newDate: { required: true },
    isDisabled: { required: true, default: false },
  },
  data() {
    return {
      dateNew: 0,
      width: 120,
      xScale: null,
      tooltip: null,
      tooltipWidth: 60,
    };
  },
  created() {
    this.D3Chart = new SliderRefactor("slider-forecast");
  },
  watch: {
    minIdx(val) {
      this.dateNew.splice(0, 1, val);
    },
    newDate(date) {
      if (date === -1) return;
      else this.handleSliderChange(date);
    },
  },
  mounted() {
    this.dateNew = this.minIdx;
    this.slider();
  },
  methods: {
    slider() {
      const sliderElement = document.querySelector(".p-slider-horizontal");
      const sliderWidth = sliderElement.clientWidth;
      this.D3Chart.setScale({
        data: this.dates,
        sliderName: "p-slider-horizontal",
        heightSvg: 30,
        axisValue: "xScale",
      });

      this.D3Chart.setTicks({
        axisPosition: axisBottom,
        axisValue: "xScale",
        coordinate: "x",
        tickCount: 6,
        tickSize: 10,
        tickFormat: "%b/%y",
      });
      const g = select("g.ticks");

      const bbox = g.node().getBBox();
      select("#svg-slider-forecast").attr("width", bbox.width);
      g.attr("transform", `translate(${(bbox.width - sliderWidth) / 2}, 0)`);

      g.selectAll(".ticks text").style("font-size", "0.6rem");

      this.tooltip = select("#slider-forecast-div")
        .append("div")
        .attr("class", "tooltip tooltipForecast")
        .style("position", "absolute")
        .style("width", this.tooltipWidth + "px")
        .style("font-size", "0.7rem")
        .style("opacity", 0)
        .style("font-weight", "bold")
        .style("text-align", "center");
    },
    handleSliderChange(value) {
      const valuePercent = 100 / (this.dates.length - 1);
      const tooltipLeft = value * valuePercent;
      const sliderWidth = document.querySelector(".p-slider-horizontal")
        .clientWidth;
      const percentTooltip = (100 * (this.tooltipWidth / 2)) / sliderWidth;

      this.tooltip
        .style("opacity", 1)
        .style("left", `${tooltipLeft - percentTooltip}%`)
        .style("top", "8px")
        .html(timeFormat("%d/%b/%y")(this.dates[value]));

      this.$emit("eventOnRangeChange", this.dates[value]);
      this.$emit("eventOnValueChange", this.dateNew);
    },
    onUserSlider(event) {
      this.dateNew = event;
    },
  },
};
</script>

<style>
.p-slider span.p-slider-range {
  background: var(--lightbackground);
}
.slider__container .p-slider.p-slider-horizontal .p-slider-handle {
  z-index: 10;
  background: var(--dark-fwd);
  border: 1px solid var(--fwd);
}
.slider__container .p-slider.p-slider-horizontal .p-slider-handle:hover {
  background: var(--dark-fwd);
  border: 1px solid var(--fwd);
}
.tick line,
.domain {
  stroke: var(--lightbackground);
}
.slider__container .p-slider.p-slider-horizontal {
  height: 0.1rem;
}
.domain {
  stroke: var(--lightbackground);
}
.slider__container label.toggle__button_g {
  max-width: 80px;
  flex-direction: column;
  width: max-content;
}
.slider__container .p-slider.p-disabled .p-slider-handle {
  background: var(--lighterbackground);
  border: 1px solid var(--lightbackground);
}
.tooltipForecast {
  background: var(--dark-fwd);
  border: 1px solid var(--fwd);
  color: var(--textactive-2);
}
</style>
